/* @flow */

import { type EstimarPedidoVariables } from './types';
import { CREATE_ORDER } from './querys';
import loggiClient from './loggiClient';

type Retorno = {
    data: {
        createOrder: {
            success: boolean,
            errors: Array<{
                field: ?string,
                message: string,
            }>,
            orders: {
                pk: number,
            }
        },
    },
};

const createOrder = (variables: EstimarPedidoVariables): Promise<Retorno> => (
    loggiClient.mutate({ mutation: CREATE_ORDER, variables })
);

export default createOrder;
